import React from 'react'
import WarningPanel from '../../components/WarningPanel'

export default {
  2015: {
    description: `Room at capacity`,
    text: (
      <WarningPanel>
        <p>This talk already has a maximum number of presenters.</p>
        <p>If you require access, please contact the organizer.</p>
      </WarningPanel>
    )
  },
  default: {
    description: `Unexpected error`,
    text: (
      <WarningPanel>
        <p>An unexpected error has occurred.</p>
        <p>Please speak to your administrator.</p>
      </WarningPanel>
    )
  }
}
